import { getTracking } from '@vp/tracking';

const ImageTrackingCategory = 'Image';
const HeroGalleryThumbnailTrackingLabel = 'Hero Gallery Thumbnail';

export function sendMediaEngaged(position: number, mpvId: string, productKey: string): void {
  try {
    const tracking = getTracking();

    if (!tracking) {
      console.error('Tracking not loaded');
      return;
    }

    const payload: IMediaEngagedPayload = {
      category: ImageTrackingCategory,
      label: HeroGalleryThumbnailTrackingLabel,
      eventDetail: `position_${position}`,
      product_id: mpvId,
      core_product_id: productKey,
    };
    tracking.track('Media Engaged', payload);
  } catch (exception) {
    console.error('Tracking call failed: ', exception);
  }
}

export interface IMediaEngagedPayload {
  category: string;
  label: string;
  eventDetail: string;
  product_id: string;
  core_product_id: string;
}
